var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppleAuth = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 22 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.124 17.608c-.564 1.249-.832 1.808-1.558 2.91-1.01 1.544-2.44 3.467-4.208 3.478-1.57.015-1.975-1.024-4.108-1.006-2.133.008-2.579 1.025-4.152 1.01-1.765-.015-3.117-1.75-4.13-3.287C.134 16.4-.164 11.34 1.586 8.651c1.238-1.909 3.198-3.029 5.04-3.029 1.872 0 3.05 1.028 4.602 1.028 1.503 0 2.417-1.031 4.587-1.031 1.636 0 3.371.891 4.61 2.435-4.054 2.218-3.394 8.006.7 9.554M14.168 3.894c.789-1.01 1.385-2.439 1.172-3.894-1.29.088-2.793.91-3.674 1.971-.795.97-1.455 2.41-1.197 3.802 1.404.045 2.855-.792 3.7-1.879"
})));
export default SvgAppleAuth;